<div class="row">
  <div class="col-12 col-sm-8">
    <p>
      EuroGeographics reviews its privacy notice regularly and will place any updates on this page.
      This privacy policy only applies to EuroGeographics and its websites, including Open Maps For
      Europe.
    </p>
    <p>
      We are not responsible for the privacy practices within any other websites that you may link
      to from this site.
    </p>
    <p>
      We use traffic log cookies to identify which pages are being used. This helps us to analyse
      data about the web traffic and improve our website. We only use this information for
      statistical analysis.
    </p>

    <h2 class="h3">Who are we?</h2>
    <p>
      For the purposes of the General Data Protection Regulation (Regulation (EU) 2016/679) (GDPR),
      EuroGeographics, Rue du Nord 76/Noordstraat 76, 1000 Brussels, BELGIUM, +32 2 888 71 93
      <a href="mailto:contact@eurogeographics.org">contact@eurogeographics.org</a> is the
      ‘controller’ of your personal data, and we comply with the Regulation’s requirements in
      respect of the collection, management and disclosure of your personal information.
      EuroGeographics Data Protection Office (DPO) is Sallie Payne-Snell, Head of Operations,
      <a href="mailto:sallie.payne@eurogeographics.org">sallie.payne@eurogeographics.org</a>.
    </p>
    <p>
      This privacy statement explains the reason for the way EuroGeographics collects, processes,
      handles and ensures the protection of all personal data provided, how that information is used
      and what rights you may exercise in relation to your data.
    </p>
    <h2 class="h3">Why do we process your data?</h2>
    <p>
      EuroGeographics keeps a minimum amount of personal information. We collect and use your
      personal information to enable the smooth running of the membership association and to deliver
      pan-European projects, datasets and services.
    </p>
    <h2 class="h3">Which data do we collect and process?</h2>
    <p>
      The personal information collected and further processed is provided on a voluntary basis by
      the data subject (in this case you) or by an authorised person with the permission
      of/nominated by the data subject. The data subject has the right to withdraw his/her content
      at any time.
    </p>
    <p>
      The type of personal data we collect consists of: Nationality; Full Name; Position;
      Profession, Occupation /Job Title; Business address, Telephone, Fax, email and Twitter
      account.
    </p>
    <h2 class="h3">
      Photos/pictures, presentations, live web streaming and/or audio and video recordings
    </h2>
    <p>
      Photos/pictures, presentations, live web streaming and/or audio and video recordings may be
      taken during membership activities, for example Knowledge Exchange Network (KEN) meetings and
      General Assemblies, and used in EuroGeographics communications including social media.
    </p>

    <h2 class="h3">How long do we keep your data?</h2>
    <p>
      EuroGeographics keeps the data for the time necessary to fulfil the purpose of collection as
      stated above.
    </p>
    <h2 class="h3">How do we protect your data?</h2>
    <p>
      EuroGeographics carefully protects your data from loss, misuse, unauthorised access,
      disclosure or alteration in line with information governance policies. All data in electronic
      format (e-mails, documents etc.) are stored securely.
    </p>
    <h2 class="h3">Who has access to your data and to whom is it disclosed?</h2>
    <p>
      Access to your data is provided to authorised staff according to the ‘need to know’ principle.
    </p>
    <p>
      When required, access to personal data will be provided to our appointed internal and external
      auditors.
    </p>
    <p>
      No personal data will be transmitted to parties which are outside the recipients mentioned in
      this privacy statement without the prior consent of the data subject.
    </p>
    <h2 class="h3">Access to personal information</h2>
    <p>
      You can find out if we hold any personal information about you by making a request to
      <a href="mailto:contact@eurogeographics.org" target="_top"
        >contact@eurogeographics.org<i class="bi bi-box-arrow-up-right ms-1"></i
      ></a>
    </p>
    <p>If we do hold information about you, we will:</p>
    <ul>
      <li>Provide a description of the data we hold;</li>
      <li>Explain the reasons we are holding the data;</li>
      <li>Tell you to whom the data could be disclosed;</li>
      <li>Provide a copy of the information in an intelligible form.</li>
    </ul>
    <h2 class="h3">Complaints or Queries</h2>
    <p>
      If you think that EuroGeographics collection or use of personal information is unfair,
      misleading or inappropriate please contact us through contact@eurogeographics.org or by post
      to EuroGeographics Head Office, Rue du Nord 76/Noordstraat 76, 1000 Brussels, BELGIUM
    </p>
    <h2 class="h3">Rights</h2>
    <p>
      You have the right to request access to and rectification or erasure of personal data or
      restriction of processing and to object to processing as well as the right to data
      portability. You also have the right to lodge a complaint with a supervisory authority and to
      withdraw consent at any time, without affecting the lawfulness of processing based on consent
      before its withdrawal.
    </p>
  </div>
</div>
